export default "__VITE_ASSET__Bu6qeYsK__"